<!-- 采购收数据操作 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <purchaseReceiptTemplate ref="purchaseReceiptTemplate"></purchaseReceiptTemplate>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <!-- 采购验收主表单 -->
                           <el-form class="baseForm" id="mainInfo" label-width="150px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row v-if="dataActionBox.actionType != 2" ref="baseForm">
                                 <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                               :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []" v-if="formOneValue.isShow == 1">
                                    <template>
                                       <!-- 系统字段 -->
                                       <div v-if="formOneValue.isReserved == 0">
                                          <!-- 收货单号 -->
                                          <el-tooltip v-if="formOneValue.fieldType == 'extract'" class="item"
                                                      :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                      effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                             <el-input v-if="formOneValue.fieldType == 'extract'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                       @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                       :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                           :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                </el-button>
                                             </el-input>
                                          </el-tooltip>
                                          <df-date v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false" v-model="sendDataInfo[formOneValue.entityField]" :isdisabled="true"></df-date>
                                          <!-- 第二验收人 -->
                                          <el-input clearable title="second" :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'pscadSeccher'" v-model="sendDataInfo.pscadSeccherName"
                                                    @focus="dialogFormVisible = true">
                                          </el-input>
                                          <el-input v-else :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                       </div>
                                    </template>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                               :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []" v-if="formOneValue.isShow == 1">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <!-- 系统字段 -->
                                    <div v-if="formOneValue.isReserved == 0">
                                       <span v-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                            sendDataInfo[formOneValue.entityField]
                                                        }}</a>
                                       </span>
                                       <span v-else-if="formOneValue.entityField == 'pscadSeccher'">{{
                                                        sendDataInfo.pscadSeccherName
                                                    }}</span>
                                       <span v-else-if="formOneValue.fieldType == 'date'">
                                          <span v-if="sendDataInfo[formOneValue.entityField]">
                                             {{
                                                                $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                            }}
                                          </span>
                                       </span>
                                       <span v-else-if="formOneValue.fieldType == 'formatter'">{{ getValue(sendDataInfo[formOneValue.entityField],
                                                            formOneValue.entityField, formOneValue.fieldType,
                                                        formOneValue.formatterContent)}}</span>
                                       <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                    </div>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 查询 -->
                           <el-row id="operateBtn1">
                              <el-col :span="21">
                                 <el-button v-if="dataActionBox.actionType != 2" type="primary" size="mini" @click="lookLicence()">查看证照</el-button>
                                 <el-button v-if="dataActionBox.actionType != 2" type="primary" size="mini" @click="UDIclick()">UDI扫码</el-button>
                                 <el-button v-if="dataActionBox.actionType != 2" type="primary" size="mini" @click="del()">删除</el-button>
								 <!-- <OCR_recognition style="margin-left: 5px;" :name="'随货同行单'" @OCRResult="OCRResult" :title="'随货同行单识别'"></OCR_recognition> -->
                              </el-col>
                           </el-row>
                           <el-form :inline="true" size="mini">
                              <el-table border style="width: 100%" :data="sendDataInfo.pschaSplitDetailAdds" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" size="mini" :height="mxHeight"
                                        @row-click="rowClick">
                                 <el-table-column type="index" label="序号"></el-table-column>
                                 <el-table-column align="center" v-for="(formOneValue) in mxForm" :key="formOneValue.psrgmId" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip
                                                  :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow == 1">
                                    <template slot="header" slot-scope="scope">
                                       <div class="item-top">
                                          <span class="gray-txt">{{ formOneValue.showField }}</span>
                                          <el-popover class="popover" v-if="formOneValue.entityField == 'pscadSchnumber'" placement="top-start" title="抽检规则" width="200" trigger="hover" :content="popTitle">
                                             <i slot="reference" class="el-icon-question" style="font-size: 16px" />
                                          </el-popover>
                                       </div>
                                    </template>
                                    <template slot-scope="scope">
                                       <div v-if="dataActionBox.actionType != 2">
                                          <span v-if="formOneValue.isRift == 1">
                                             <a
                                                @click="toDetail(sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.riftField])">{{ sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]}}</a>
                                          </span>
                                          <span v-else-if="formOneValue.entityField == 'pscadSeccher'">
                                             {{ sendDataInfo.pschaSplitDetailAdds[scope.$index].pscadSeccherName }}
                                          </span>
                                          <el-tag size="mini" v-else-if="formOneValue.entityField == 'bgiIsdcheck'">
                                             {{ sendDataInfo.pschaSplitDetailAdds[scope.$index].bgiIsdcheck == 0 ? '否' : '是' }}
                                          </el-tag>
                                          <!-- 批号 -->
                                          <el-input v-else-if="formOneValue.entityField == 'batchno'" v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]" :ref="formOneValue.entityField"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)" :maxlength="$store.state.inputLength"></el-input>
                                          <!-- 失效日期 -->
                                          <df-date :isType="true" :isShowLong="false" v-else-if="formOneValue.entityField == 'expidate' && dataActionBox.actionType != 2"
                                                   :isdisabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField" :class="formOneValue.entityField" :isLongTime="false"
                                                   :isNull="true" :isError="false" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index,formOneValue.entityField)"
                                                   v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]">
                                          </df-date>
                                          <!-- 生产日期 -->
                                          <df-date :isType="true" :isShowLong="false" v-else-if="formOneValue.entityField == 'prodate' && dataActionBox.actionType != 2"
                                                   :isdisabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField" :class="formOneValue.entityField" :isLongTime="false"
                                                   :isNull="true" :isError="true" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index,formOneValue.entityField)"
                                                   v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]">
                                          </df-date>
                                          <!-- 日期 -->
                                          <df-date :isType="true" :isShowLong="false" v-else-if="formOneValue.fieldType == 'date' && dataActionBox.actionType != 2"
                                                   :isdisabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField" :class="formOneValue.entityField" :isLongTime="false"
                                                   :isNull="true" :isError="false" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index,formOneValue.entityField)"
                                                   v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]">
                                          </df-date>
                                          <!-- 验收合格数量 -->
                                          <el-input v-else-if="formOneValue.entityField == 'pscadQuanumber'" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)"
                                                    @blur="getCJ(scope.$index,true)" v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]" type="number" :min="0"
                                                    :ref="formOneValue.entityField" :class="formOneValue.entityField" onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"></el-input>
                                          <!-- 不合格数量 -->
                                          <el-input @blur="getCJ(scope.$index,true)" v-else-if="formOneValue.entityField == 'pscadRefnumber'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0"
                                                    :ref="formOneValue.entityField" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)"
                                                    v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]" type="number" :min="0"
                                                    onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"></el-input>
                                          <!-- 拒收数量 -->
                                          <el-input v-else-if="formOneValue.entityField == 'pscadRejectnumber'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField"
                                                    @blur="tableNextFocus(formOneValue.focusField||'pscadSchnumber', scope.$index)"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField||'pscadSchnumber', scope.$index)"
                                                    v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]" type="number" :min="0"
                                                    onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"></el-input>
                                          <!-- 抽检数量 -->
                                          <el-input v-else-if="formOneValue.entityField == 'pscadSchnumber'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" :ref="formOneValue.entityField"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]"
                                                    type="number" :min="0"></el-input>
                                          <!-- 验收结论 -->
                                          <el-select :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'pscadCheckcon'" :ref="formOneValue.entityField"
                                                     :id="formOneValue.entityField" @visible-change="()=>{tableNextFocus(formOneValue.focusField, scope.$index)}"
                                                     v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]">
                                             <el-option v-for="(storageRoomValue, storageRoomKey) in ['合格', '不合格']" :key="storageRoomKey" :label="storageRoomValue" :value="storageRoomValue">
                                             </el-option>
                                          </el-select>
                                          <el-input v-else-if="formOneValue.entityField == 'sterBatchno'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0"
                                                    v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]" :ref="formOneValue.entityField"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :maxlength="$store.state.inputLength"></el-input>
                                          <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]"
                                                    :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                    :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                             <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                                        icon="el-icon-search" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                             </el-button>
                                          </el-input>
                                          <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                                     @change="$forceUpdate()" v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                             <el-option v-for="(item, index) in JSON.parse(formOneValue.formatterContent)" :key="index" :label="item.key" :value="item.value">
                                             </el-option>
                                          </el-select>
                                          <el-input v-else-if="formOneValue.entityField == 'pscadRemark'" :disabled="dataActionBox.actionType == 2 || formOneValue.isChange == 0"
                                                    v-model="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]" :ref="formOneValue.entityField"
                                                    @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, formOneValue.entityField)" :maxlength="$store.state.inputLength"></el-input>
                                          <span v-else>
                                             {{ sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField] }}
                                          </span>
                                       </div>
                                       <div v-else>
                                          <span v-if="formOneValue.isRift == 1">
                                             <a @click="toDetail(sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.riftField])">
                                                {{sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]}}
                                             </a>
                                          </span>
                                          <span v-else-if="formOneValue.fieldType == 'date'">
                                             <span v-if="sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]">
                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                             </span>
                                          </span>
                                          <span v-else>{{sendDataInfo.pschaSplitDetailAdds[scope.$index][formOneValue.entityField]}}</span>
                                       </div>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" label="验收状态" width="110">
                                    <template slot-scope="scope">
                                       <el-link v-if="scope.row.checkState == 0" type="danger" :underline="false">未验收</el-link>
                                       <el-link v-if="scope.row.checkState == 1" type="warning" :underline="false">部分验收</el-link>
                                       <el-link v-if="scope.row.checkState == 2" type="success" :underline="false">验收成功</el-link>
                                    </template>
                                 </el-table-column>
                              </el-table>
                           </el-form>
                        </div>
                        <!-- 冷链信息 -->
                        <div v-if="scope.index == 1">
                           <el-form size="mini" id="coldInfo" class="baseForm" label-width="150px" :show-message="false">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                                               :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <el-input disabled v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                                               :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="cancelActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>

         </div>

      </div>
      <!-- 第二验收人 -->
      <el-dialog title="选择验收人并且输入验收人的密码" :visible.sync="dialogFormVisible" :append-to-body="true" :close-on-click-modal="false">
         <el-form label-position="top">
            <el-form-item label="账户">
               <el-input v-model="reviewUserInfo.selectIndex"></el-input>
            </el-form-item>
            <el-form-item label="密码">
               <el-input type="password" v-model="reviewUserInfo.passWord"></el-input>
            </el-form-item>
         </el-form>
         <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="userVerification()">确 定</el-button>
         </div>
      </el-dialog>
      <!-- new明细提取 -->
      <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
         <ExtractionScheme ref="extractionScheme" :id="exId" :ppId="ppId" @TranData="getTiqu" @getWidth="getWidth" @sendTitle="getExtractName" />
      </el-dialog>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
      <!-- UDI扫码 -->
      <el-dialog title="UDI扫码" v-if="UDIshow" :visible.sync="UDIshow" width="98vw" top="10px" :modal-append-to-body='true' :append-to-body="true" class="dialogBox">
         <UDIscanCode :actionData="UDIobj" @clearClick="clearClick"></UDIscanCode>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
import UDIscanCode from "../udi/UDIscanCode.vue";

import purchaseReceiptTemplate from "@/components/purchaseReceiptTemplate.vue";
import OCR_recognition from "./OCR_recognition.vue";
export default {
   name: "purchaseSplitAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      ExtractionScheme,
      SearchScheme,
      UDIscanCode,
      purchaseReceiptTemplate,
      OCR_recognition
   },
   data() {
      //这里存放数据
      return {
         popTitle: "",
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {},
         showTabs: "",
         formDataList: [],
         mxHeight: 0,
         tabForm: [], // 主表单
         mxForm: [], // 明细表单
         footForm: [], //表尾
         seIndex: 0,//表单的第几个输入框
         selectedDetailsIndex: 0,
         //-----------------提取方案
         DialogExtract: false,
         exTitle: "",
         exWidth: "",
         exId: "",
         ppId: "",
         //------------------检索方案
         DialogVisible: false,
         seId: "",
         seIndex: 0,
         seType: "",
         sField: "",
         fField: "",
         seTitle: "",
         seWidth: "",
         parentSearchData: {},
         //--------------------
         inputel: [],
         //--------------------
         selectedRow: [],
         newTime: "",
         newDayTime: "",
         //---------------------
         detailRules1: false,
         detailRules2: false,
         //---------------------第二验收人
         dialogFormVisible: false,
         reviewUserInfo: {
            opmId: "",
            passWord: "",
            selectIndex: '',
         },
         //------------------------------------
         UDIobj: {},
         UDIshow: false,
         dataInfo: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   watch: {
      "sendDataInfo.pschaSplitDetailAdds": {
         handler: function (newValue, oldValue) {
            newValue.forEach(async (item, keys) => {
               this.$set(item, 'pscadQuanumber', this.$common.updataNum('pscadQuanumber', item).pscadQuanumber)
               this.$set(item, 'pscadRefnumber', this.$common.updataNum('pscadRefnumber', item).pscadRefnumber)
               this.$set(item, 'pscadSchnumber', this.$common.updataNum('pscadSchnumber', item).pscadSchnumber)
               this.$set(item, 'pscadRejectnumber', this.$common.updataNum('pscadRejectnumber', item).pscadRejectnumber)
               if ((item.prodate > this.newTime) && item.prodate != '') {
                  item.prodate = this.newTime
                  this.$refs.prodate[keys].$forceUpdate()
                  this.$message({
                     message: "生产日期不能大于今日",
                     type: "warning",
                  });
               }
               if (item.prodate != '' && item.glTervalidity != '' && (item.prodate > item.glTervalidity)) {
                  item.prodate = ""
                  this.$refs.prodate[keys].$forceUpdate()
                  this.$message({
                     message: "生产日期不能大于注册有效期",
                     type: "warning",
                  });
               }
               if (item.prodate != '' && item.glRedate != '' && (item.prodate < item.glRedate)) {
                  item.prodate = ""
                  this.$refs.prodate[keys].$forceUpdate()
                  this.$message({
                     message: "生产日期不能小于注册证发证日期",
                     type: "warning",
                  });
               }
               // if (item.expidate != null && item.expidate != '' && (item.expidate < this.newDayTime)) {
               //    item.expidate = this.newDayTime
               //    this.$refs.expidate[keys].$forceUpdate()
               //    this.$message({
               //       message: "此商品已经失效，失效范围小于等于当天",
               //       type: "warning",
               //    });
               // }
            })
         },
         deep: true,
      }
   },
   methods: {
      OCRResult(data) {
         console.log(data)
      },
      async UDIclick() {
         if (this.sendDataInfo.pschaSplitDetailAdds.length == 0) {
            return this.$message.error("请先提取采购收货单！")
         }
         const res = await this.$http.queryUdiPutin({ ids: [this.sendDataInfo.psrgmId] })
         if (res.status == 200) {

            if (res.result.length > 0) {
               var list = []
               res.result.forEach(item => {
                  this.$set(item, 'type', "已保存")
                  list.push(item)
               })
               this.UDIobj = {
                  data: this.dataInfo,
                  UDIlist: list
               }
            } else {
               this.UDIobj = {
                  data: this.dataInfo,
                  UDIlist: []
               }
            }
         }
         this.UDIshow = true

      },
      clearClick(flag, val) {
         if (flag) {
            var list = []
            this.dataInfo.pschaSplitDetailAdds.forEach(item => {
               var arr = val.filter(val => val.bgmId == item.bgmId)
               if (arr.length > 0) {
                  var num = item.psrgdRecnumber
                  arr.forEach((item1, index) => {
                     var obj = JSON.parse(JSON.stringify(item))
                     for (const key in item1) {
                        if (item1[key] && key != 'bgColor') {
                           this.$set(obj, key, item1[key])
                        }
                     }
                     this.$set(obj, 'pscadQuanumber', obj.inNum)
                     if ((num - obj.inNum) > 0) {
                        if (index != arr.length - 1) {
                           num = num - obj.inNum
                           this.$set(obj, 'psrgdRecnumber', obj.inNum)
                           this.$set(obj, 'checkState', 2)
                        } else {
                           this.$set(obj, 'psrgdRecnumber', num)
                           this.$set(obj, 'checkState', 1)
                        }
                     } else if ((num - obj.inNum) == 0) {
                        this.$set(obj, 'psrgdRecnumber', obj.inNum)
                        this.$set(obj, 'checkState', 2)
                     }
                     list.push(obj)
                  })
               } else {
                  list.push(item)
               }
            })
            this.sendDataInfo.pschaSplitDetailAdds = list
         }
         this.UDIshow = false
      },
      // 验收人验证
      async userVerification() {
         var pscadSeccherObj = {
            opmAccount: this.reviewUserInfo.selectIndex,
            passWord: this.reviewUserInfo.passWord,
         };

         let res = await this.$http.reviewVerification(pscadSeccherObj);
         if (res.status == 200) {
            this.reviewUserInfo.selectIndex = res.result.opmName
            this.dialogFormVisible = false;
            this.sendDataInfo.pscadSeccher = res.result.opmId;
            this.$set(this.sendDataInfo, 'pscadSeccherName', res.result.opmName)
         } else {
            this.$message({
               message: res.message,
               type: "error",
            });
         }
      },
      // 查看证照
      lookLicence() {
         if (this.sendDataInfo.smId == "") {
            return this.$message({
               message: "请先选择供货单位",
               type: "warning",
            });
         }
         this.$parent.$parent.toDetail(this.sendDataInfo.smId);
      },
      rowClick(row, column, event) {
         this.selectedDetailsIndex = this.sendDataInfo.pschaSplitDetailAdds.indexOf(row)
         this.selectedRow = [this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex]]; // 保存已选择行
      },
      getTimestamp() {
         this.newTime = new Date(new Date().toLocaleDateString()).getTime() - 1 * 24 * 3600 * 1000
         this.newDayTime = Number(this.$common.getNewDayTime() * 1 + 86400000)
      },
      closeChild() {
         addEventListener('keyup', this.keyUp)//创建监听键盘事件
      },
      //----------------------------检索方案
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
      openSearch(sId, index, type, sField, fField, nosField) {
         removeEventListener('keyup', this.keyUp)
         removeEventListener('keyup', this.keyUpEnter)
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.fField = fField;
         if (type == "bgiRegistno") {
            this.parentSearchData['bgmId'] = this.sendDataInfo.pschaSplitDetailAdds[index][type]
         } else {
            this.parentSearchData[type] = this.sendDataInfo.pschaSplitDetailAdds[index][type];
         }
      },
      changeInputModel(val) {
         console.log('检索', val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            addEventListener('keyup', this.keyUp)
            this.paramValue(val);
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.$set(this.sendDataInfo.pschaSplitDetailAdds[this.seIndex], item, val[item])
         });
         this.$nextTick(() => {
            this.tableNextFocus(this.fField, this.seIndex);
         });
      },
      // 表格方法
      rowClassName({ row, rowIndex }) {
         let rowName = "",
            findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
         if (findRow) {
            rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
         }
         return rowName; //也可以再加上其他类名 如果有需求的话
      },
      // 选中行底色逻辑
      rowStyle({ row, rowIndex }) {
         Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false
         });
         let rowBackground = {}
         if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
         return rowBackground
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      openExComponents(e, index) {
         this.DialogExtract = true;
         this.seIndex = index;
         this.exId = e;
      },
      //提取明细信息
      async getTiqu(val) {
         console.log("提回", JSON.parse(JSON.stringify(val)));
         this.DialogExtract = false;
         if (val != null && val != "") {
            for (const key in val) {
               this.$set(this.sendDataInfo, key, val[key])
            }
            this.$set(this.sendDataInfo, 'pschaSplitDetailAdds', val.arrlistbychen)
            var arr = this.mxForm.filter(val => val.defaultValue != "" && val.defaultValue != null)
            var numberArr = this.mxForm.filter(val => val.fieldType == 'number')
            this.sendDataInfo.pschaSplitDetailAdds.forEach((item, index) => {
               this.$set(item, 'checkState', 0)
               this.getCJ(index)
               arr.forEach(val => {
                  if (!item[val.entityField]) {
                     this.$set(item, val.entityField, val.defaultValue)
                  }
               })
               numberArr.forEach(val => {
                  if (!item[val.entityField]) {
                     this.$set(item, val.entityField, 0)
                  }
               })
               this.$set(item, 'pscadQuanumber', item.psrgdRecnumber)//验收合格数量
               this.$set(item, 'pscadSchnumber', item.psrgdRecnumber)//抽检数量
               this.$set(item, 'pscadCheckcon', "合格")
            })
            this.selectedRow = [this.sendDataInfo.pschaSplitDetailAdds[0]]; // 保存已选择行
            this.dataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))
            this.$nextTick(() => {
               this.tableNextFocus("batchno", 0)
            })
         }
      },
      async getCJ(index, flag) {
         this.$set(this.sendDataInfo.pschaSplitDetailAdds[index], 'pscadSchnumber', this.sendDataInfo.pschaSplitDetailAdds[index].pscadQuanumber)//抽检数量
         return
      },
      //打印
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      //确认新增
      async sendDataAction() {
         this.$refs["sendDataInfo"].validate((valid) => {
            if (valid) {
               var flag = false
               var flag1 = false
               var index1 = 0
               this.sendDataInfo.pschaSplitDetailAdds.forEach((item, index) => {
                  let num = Number(item.pscadQuanumber) + Number(item.pscadRefnumber) + Number(item.pscadRejectnumber)
                  if (num != item.psrgdRecnumber && !flag1) {
                     item.checkState = 0
                     flag1 = true
                     index1 = index
                  }
                  if (item.checkState != 2 && !flag) {
                     flag = true
                  }
               })
               if (flag1) {
                  this.selectedDetailsIndex = index1
                  return this.$message.error(`序号为${index1 + 1}的商品,验收合格数量、不合格数量、拒收数量之和不能大于总件数`)
               }
               if (flag) {
                  return this.$message.error("有商品没有验收完成，请检查！")
               }
               this.sub()
            } else {
               return this.$message({
                  message: "请完善主信息",
                  type: "error",
               });
            }
         });
      },
      async sub() {
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         var responseData;
         if (this.dataActionBox.actionType == 0) {
            responseData = await this.$http.pschaaddSplit(sendData); //新增
         } else {
            responseData = await this.$http.pschamodifySplit(sendData); //修改
         }
         if (responseData.status == 200) {
            this.$refs["sendDataInfo"].resetFields();
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit("drawerCancel", 1);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //取消新增
      cancelActionBox() {
         this.$confirm("将会清除改动的数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         }).then(() => {
            this.$common.delOrderInfo(this.sendDataInfo.psrgmId)
            this.$emit("drawerCancel", 0);
            this.initActionBox();
            this.$refs["sendDataInfo"].resetFields();
         }).catch(() => { });
      },
      //接收父组件传值
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         this.filterMainField();
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            for (const key in this.sendDataInfo) {
               this.$set(this.sendDataInfo, key, oldData[key])
            }
            this.sendDataInfo.pschaSplitDetailAdds.forEach(item => {
               this.$set(item, "checkState", 2)
               this.$set(item, 'psrgdRecnumber', Number(item.pscadQuanumber) + Number(item.pscadRefnumber) + Number(item.pscadRejectnumber))
            })
            this.$set(this.sendDataInfo, 'pscamId', oldData['pscamId'])
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
         } else {
            for (const key in this.sendDataInfo) {
               this.$set(this.sendDataInfo, key, oldData[key])
            }
            this.sendDataInfo.pschaSplitDetailAdds.forEach(item => {
               this.$set(item, "checkState", 2)
               this.$set(item, 'psrgdRecnumber', Number(item.pscadQuanumber) + Number(item.pscadRefnumber) + Number(item.pscadRejectnumber))
            })
            this.$set(this.sendDataInfo, 'pscamId', oldData['pscamId'])
            this.dataActionBox.boxTitle = "查看信息";
         }
         this.dataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))
         this.getHeight()
      },
      getHeight() {
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.$refs['tree'].init(this.sendDataInfo.pscamId)
                  this.mxHeight = this.$common.getHeight()
               }
            }, 100)
            this.initFocus();
         });
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         var mxFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               mxFormList.push(item);
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         this.mxForm = mxFormList[0].jurconfigform;
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         var arr = [{ entityField: "pschaSplitDetailAdds" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.$set(this.sendDataInfo, 'pscadSeccherName', "")
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == "" && this.inputel[index].title != 'second') {
               this.inputel[index].focus();
               break;
            }
         }
      },
      // 获取冷链表单所有input
      getMainInput() {
         var el = document.getElementById("mainInfo");
         this.inputel = el ? el.getElementsByTagName('input') : ''
      },
      // 表格切换焦点方法
      tableNextFocus(field, index, type) {
         this.selectedDetailsIndex = index
         if (type == 'pscadQuanumber') {
            this.$set(this.sendDataInfo.pschaSplitDetailAdds[index], 'pscadSchnumber', this.sendDataInfo.pschaSplitDetailAdds[index].pscadQuanumber)
         }
         if (type == 'expidate') {
            console.log(this.sendDataInfo.pschaSplitDetailAdds[index].expidate == "");
            if (this.sendDataInfo.pschaSplitDetailAdds[index].expidate != undefined && this.sendDataInfo.pschaSplitDetailAdds[index].expidate != "" && this.sendDataInfo.pschaSplitDetailAdds[index].expidate != null && String(this.sendDataInfo.pschaSplitDetailAdds[index].expidate) != "NaN") {
               this.$http.pschacheckProdit({ ids: [this.sendDataInfo.pschaSplitDetailAdds[index].expidate] }).then(res => {
                  if (res.status == 300) {
                     this.$message.warning(res.message)
                     this.sendDataInfo.pschaSplitDetailAdds[index].pscadQuanumber = 0
                     this.sendDataInfo.pschaSplitDetailAdds[index].pscadRejectnumber = this.sendDataInfo.pschaSplitDetailAdds[index].psrgdRecnumber
                  }
               })
            }
         }
         if (field == 'prodate') {
            let ine = document.getElementsByClassName("prodate")[index].getElementsByTagName("input")[0];
            ine.focus();
            return
         } else if (field == "expidate") {
            let ine = document.getElementsByClassName("expidate")[index].getElementsByTagName("input")[0];
            ine.focus();
            return;
         }
         if (field == 'pscadSchnumber') {
            this.getCJ(this.selectedDetailsIndex, true)
         }
         if (field == "keydown") {
            var flag = false
            this.mxForm.forEach(item => {
               if (item.entityField == "expidate" || item.entityField == 'batchno' || item.entityField == 'prodate') {
                  if (item.isRequired == '1') {
                     if (this.sendDataInfo.pschaSplitDetailAdds[index].batchno == '') {
                        if (document.getElementsByClassName('el-message').length == 0) {
                           this.$message({
                              message: "批号不能为空",
                              type: "warning",
                           });
                        }
                        return flag = true
                     }
                  }


               }
            })
            if (flag) {
               return
            }

            this.$nextTick(() => {
               if (this.checkNum(index)) { //true 所有合格数量
                  // console.log('数量校验通过，进入确定方法')
                  this.addMsgDialog()
               } else {
                  // console.log('数量校验失败，单条校验方法')
                  if (this.checkOneData()) {
                     this.partCheck()
                     // console.log('单条校验成功,进入添加明细方法')
                     this.addNewBatch();
                  }
               }


            })
            // }
            return
         }
         this.$refs[field] && this.$refs[field][index].focus();
      },
      // 校验所有数量是否等于总数量
      checkNum(index) {
         let num = 0;
         let flag = true
         let info = this.sendDataInfo.pschaSplitDetailAdds[index]
         let twoNum = Number(info.pscadQuanumber) + Number(info.pscadRefnumber) + Number(info.pscadRejectnumber)
         num += twoNum
         flag = num == info.psrgdRecnumber ? true : false
         return flag;
      },
      async addMsgDialog() {
         var arr = this.sendDataInfo.pschaSplitDetailAdds.filter(item => { item.bgmId == this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex].bgmId })
         var responseData = await this.$http.checkAcceptanceLicense({
            formId: this.formDataList[3].jciId,
            psrgdId: this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex].psrgdId,
            bgmId: this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex].bgmId,
            splitProductDtoList: arr.map(item => {
               return {
                  pscadQuanumber: item.pscadQuanumber,
                  pscadRefnumber: item.pscadRefnumber,
                  pscadRejectnumber: item.pscadRejectnumber,
                  prodate: item.prodate,
                  expidate: item.expidate,
                  udiCode: "",
               }
            }),

         });
         if (!responseData || responseData.status != 200) {
            //弹窗 换行提示
            let txtArr = responseData.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
               newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
               confirmButtonText: "确定",
               callback: (action) => { },
            });
            return false;
         } else {
            this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex].checkState = 2
            this.$message({
               message: "验收成功",
               type: "success",
            });
            this.selectedRow = [this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex + 1]]; // 保存已选择行
            this.tableNextFocus("batchno", this.selectedDetailsIndex + 1);
         }
      },
      partCheck() {
         this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex].checkState = 2
         this.$message({
            message: "验收成功",
            type: "success",
         });
      },
      //添加批号
      addNewBatch() {
         this.addPschacBatch();
      },
      detailsChange() {
         var arr = this.mxForm.filter(val => val.defaultValue != "" && val.defaultValue != null)
         var numberArr = this.mxForm.filter(val => val.fieldType == 'number')
         var info = JSON.parse(JSON.stringify(this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex]))
         console.log(info,"ces");

         var obj = {
            batchno: "",
            prodate: "",
            expidate: "",
            pscadQuanumber: 0,
            pscadRefnumber: 0,
            pscadRejectnumber: 0,
            pscadSchnumber: 0,
            pscadCheckcon: "合格",
            sterBatchno: "",
            stName: "",
            stId: "",
            refstName: "",
            refstId: "",
            pscadReserves1: "",
            pscadReserves2: "",
            pscadReserves3: "",
            pscadReserves4: "",
            pscadReserves5: "",
            pscadRemark: "",
         }
         for (const key in obj) {
            if (key != 'refstId' && key != 'refstName' && key != 'stId' && key != 'stName' && !obj[key]) {
               this.$set(info, key, "")
            }
         }
         this.$set(info, 'checkState', 0)
         arr.forEach(val => {
            if (!info[val.entityField]) {
               this.$set(info, val.entityField, val.defaultValue)
            }
         })
         var arr1 = this.sendDataInfo.pschaSplitDetailAdds.filter(item => item.bgmId == info.bgmId)
         var num = 0
         var totalNum = 0
         arr1.forEach(item => {
            num = num + Number(item.pscadQuanumber) + Number(item.pscadRefnumber) + Number(item.pscadRejectnumber)
            totalNum = totalNum + Number(item.psrgdRecnumber)
         })
         this.$set(this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex], 'psrgdRecnumber', this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex].psrgdRecnumber - (totalNum - num))
         this.$set(info, 'psrgdRecnumber', totalNum - num)
         this.$set(info, 'pscadQuanumber', totalNum - num)
         this.$set(info, 'pscadSchnumber', totalNum - num)
         return info
      },
      //删除
      del() {
         if (this.sendDataInfo.pschaSplitDetailAdds.filter(item => item.bgmId == this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex].bgmId).length == 1) {
            return this.$message.error("请保留一条商品明细")
         }
         let info = this.sendDataInfo.pschaSplitDetailAdds.splice(this.selectedDetailsIndex, 1)[0]
         var arr = this.sendDataInfo.pschaSplitDetailAdds.filter(item => item.bgmId == info.bgmId)
         if (arr.length > 0) {
            this.$set(arr[arr.length - 1], 'psrgdRecnumber', Number(arr[arr.length - 1].psrgdRecnumber) + Number(info.psrgdRecnumber))
         }
      },
      addPschacBatch(reset) {
         if (this.sendDataInfo.psrgmId != '') {
            if (!this.checkOneData()) {
               return this.$message({
                  message: "无需新增批号明细",
                  type: "error",
               });
            }
         } else {
            return this.$message({
               message: "请先提取明细",
               type: "error",
            });
         }
         var arr = this.detailsChange()
         this.sendDataInfo.pschaSplitDetailAdds.splice(this.selectedDetailsIndex + 1, 0, arr)
         this.$nextTick(() => {
            setTimeout(() => {
               this.selectedRow = [this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex + 1]]; // 保存已选择行
               this.tableNextFocus("batchno", this.selectedDetailsIndex + 1);
            }, 100)
         });
      },
      checkOneData() {
         let num = 0;
         let flag = true
         var info = this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex]
         if (!info.pscadQuanumber) {
            this.$message({
               message: "请输入合理的验收数量",
               type: "error",
            });
            flag = false
            return;
         }
         let num1 = info.pscadRefnumber ? info.pscadRefnumber : 0;
         let num2 = info.pscadQuanumber ? info.pscadQuanumber : 0;
         let num3 = info.pscadRejectnumber ? info.pscadRejectnumber : 0;
         num += Number(num1) + Number(num2) + Number(num3);
         if (num > info.psrgdRecnumber) {
            this.$message({
               message: "验收合格数量、不合格数量、拒收数量之和不能大于总件数",
               type: "error",
            });
            flag = false
            this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex].checkState = 0
            return;
         } else if (info.pscadRefnumber == 0 && info.pscadQuanumber == 0) {
            this.$message({
               message: "请输入合理的验收数量",
               type: "error",
            });
            flag = false
            this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex].checkState = 0
            return;
            // }else if(num == this.pschacBatchDetails.psrgdRecnumber){
         } else if (info.pscadSchnumber > num) {
            this.$message({
               message: "抽检数量不能大于合格数量、不合格数量、拒收数量之和",
               type: "error",
            });
            flag = false
            this.sendDataInfo.pschaSplitDetailAdds[this.selectedDetailsIndex].checkState = 0
            return;
         } else if (info.pscadQuanumber == info.psrgdRecnumber) {
            flag = false
            return;
         } else if (info.pscadQuanumber > 0 && info.stId == '') {
            this.$message({
               message: "请选择合格库房",
               type: "error",
            });
            flag = false
            return;
         } else if (info.pscadRefnumber > 0 && info.refstId == '') {
            this.$message({
               message: "请选择不合格库房",
               type: "error",
            });
            flag = false
            return;
         }
         return flag;
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.openBox();
      this.getTimestamp()
      this.$dbCache.Record_Get(9).then((res) => {//采购验收必须要填写抽检数量校验
         //抽检数量拦截
         let obj = res
         if (obj.isEnable == 1) this.detailRules1 = true;
      });
      this.$dbCache.Record_Get(11).then((res) => {//采购特殊药品必须要填写第二验收人
         //第二验收拦截
         let obj = res
         console.log(obj);
         if (obj.isEnable == 1) this.detailRules2 = true;
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      this.ppId = "psrgmId";
      addEventListener('keyup', this.keyUp)//创建监听键盘事件
      addEventListener('keyup', this.keyUpEnter)//创建监听键盘事件
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput();
   }, //生命周期 - 更新之后
   beforeDestroy() {
      removeEventListener('keyup', this.keyUp)
      removeEventListener('keyup', this.keyUpEnter)
   }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   /* padding-right: 20px; */
}

.pihaoDialog .el-dialog {
   min-height: 60%;
}

.el-drawer {
   outline: none;
}

#dia .el-date-editor.el-input,
#dia .el-date-editor.el-input__inner {
   width: 100% !important;
}

::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-textarea.is-disabled .el-textarea__inner {
   background-color: #fff;
   color: #333;
}

::v-deep
   .el-radio-button__orig-radio:disabled:checked
   + .el-radio-button__inner {
   background-color: #ccc;
}

::v-deep .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
   color: #333;
}
.dialogBox ::v-deep .el-dialog {
   margin-bottom: 0;
}
</style>